import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import { Virtuoso } from 'react-virtuoso'
import i18n from 'i18next'
import Typography from '../../../UniformComponents/Typography'
import Badge from '../../../UniformComponents/Badge'
import AiOverview from '../../ReportV2/components/RightPanel/ReportQuestions/AiOverview'
import Button from '../../../UniformComponents/Button'

import './textResponseChart.scss'

@observer
class TextResponseChart extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentYear: undefined,
            coding: undefined,
            codingFilter: new Set(),
            generatingSummary: false,
            responses: undefined,
        }
    }

    async componentDidMount() {
        const { aiEnabled, preview } = this.props
        if (aiEnabled && !preview) {
            await this.getCodedData()
        }
    }

    getCodedData = async () => {
        const { dashStore, element } = this.props
        const { getTextSurveyId, checkIsSurveyClosed } = dashStore
        const surveyId = getTextSurveyId(element)
        const isClosed = checkIsSurveyClosed(surveyId)
        const {
            numberOfResponses,
            aiState,
            responses,
            isLoading,
            sentiment,
            sentimentFilter,
            coding,
            codingFilter,
        } = await dashStore.getTextQuestionReportData(element, surveyId)
        console.log('THTEST isClosed', isClosed)
        this.setState({
            numberOfResponses,
            aiState,
            responses,
            isLoading,
            sentiment,
            sentimentFilter,
            coding,
            codingFilter,
            isSurveyClosed: isClosed,
        })
    }

    toggleCodingFilter = (code) => {
        const { codingFilter } = this.state

        const clonedSet = new Set(codingFilter)

        if (clonedSet.has(code)) {
            clonedSet.delete(code)
        } else {
            clonedSet.add(code)
        }

        this.setState({
            codingFilter: clonedSet,
        })
    }

    renderCoding = () => {
        const { coding, codingFilter } = this.state
        if (!coding) return null
        if (Object.values(coding).reduce((a, { value }) => a + value, 0) === 0) return null

        return (
            <div className="codingSummary">
                <Typography type="h3">Filter by Theme:</Typography>
                <div>
                    {coding.map(({ name, value }) => (
                        <Badge
                            isRounded
                            label={`${name} (${value})`}
                            type={codingFilter.has(name) ? 'success' : 'grey'}
                            onClick={() => this.toggleCodingFilter(name)}
                        />
                    ))}
                </div>
            </div>
        )
    }

    renderResponses = () => {
        const { chartData, defaultYear, iconColour } = this.props
        const { currentYear, responses, codingFilter } = this.state
        if (!currentYear && !defaultYear) return null
        const selectedYear = currentYear || defaultYear
        const yearData = responses && responses.length ? responses : R.pathOr([], ['data'], chartData.find((d) => d.year === selectedYear)).slice()
        const sortedData = yearData
            .sort((a, b) => (a.numberOfResponses ? b.numberOfResponses - a.numberOfResponses : 0))
        let filteredData

        if (responses && responses.length && codingFilter.size) {
            filteredData = sortedData.filter((d) => codingFilter.intersection(d.coding).size)
        } else {
            filteredData = yearData
        }

        return (
            <div style={{
                height: '100%', overflow: 'hidden', boxSizing: 'border-box',
            }}
            >
                <Virtuoso
                    style={{ height: '100%' }}
                    data={filteredData}
                    itemContent={(index, r) => (
                        <div className="response">
                            <div className="responseIcon">
                                <i className="fa-solid fa-quote-left" style={{ color: iconColour || '#16CCC1' }} />
                            </div>
                            <div className="responseText">{responses && responses.length ? r.label : r.response}</div>
                            <div className="responseCount">
                                (
                                {r.numberOfResponses}
                                )
                            </div>
                        </div>
                    )}
                />
            </div>
        )
    }

    renderYearSelector = () => {
        const { years, defaultYear } = this.props
        const { currentYear } = this.state
        if (!years || years.length === 1) return null
        const selectedYear = currentYear || defaultYear
        const sortedYears = years.sort((a, b) => b - a)
        return (
            <div className="yearSelector">
                {sortedYears.map((y) => (
                    <div className={`year ${selectedYear === y ? 'active' : ''}`} onClick={() => this.setState({ currentYear: y })}>{y}</div>
                ))}
            </div>
        )
    }

    shouldShowGenerateBtn = (aiState, isSurveyClosed) => {
        let showButton = false
        if (['generate', 'notGenerated'].includes(aiState)) showButton = true
        if (isSurveyClosed && ['outOfDate', 'upToDate'].includes(aiState)) showButton = true
        return showButton
    }

    refreshCodedData = async () => {
        const { loadThemeAndSentiment, element } = this.props
        this.setState({ generatingSummary: true })
        await loadThemeAndSentiment(element)
        await this.getCodedData()
        this.setState({ generatingSummary: false })
    }

    render() {
        const {
            title,
            height,
            aiEnabled,
            preview,
        } = this.props

        const { generatingSummary, aiState, isSurveyClosed } = this.state

        return (
            <div className="textResponseChart" style={{ height: `${height}px`, display: 'flex', flexDirection: 'column' }}>
                <div className="header">{title}</div>
                {aiEnabled && !preview ? (
                    <>
                        {this.shouldShowGenerateBtn(aiState, isSurveyClosed) ? (
                            <AiOverview
                                store={{ generatingSummary }}
                                summary={i18n.t(`report.verbatim.aiCoding.${aiState}${isSurveyClosed ? '.closedSurvey' : ''}`)}
                            >
                                <Button
                                    label="Generate themes and sentiment"
                                    cssClass="regular"
                                    variant="secondary"
                                    icon="fas fa-sparkles"
                                    onClick={() => this.refreshCodedData()}
                                    disabled={generatingSummary}
                                />
                            </AiOverview>
                        ) : null }
                        {this.renderCoding()}
                    </>
                ) : this.renderYearSelector()}

                <div className="responses" style={{ flex: 1 }}>{this.renderResponses()}</div>
            </div>
        )
    }
}

export default TextResponseChart
